export const module_ = {
    object: 'AssetPartition',
    name: 'LiberalityBeneficiary',
    filters: ['byBeneficiary'],
    tKey: 'Bénéficiaire',
    category: {
        path: 'menuTitle_liberalities',
        icon: 'testament'
    },
    newable: false,
    editable: false,
    removable: false,
    viewMap: {
        dt: [
            {path: 'assetInfos.applicationNumber', tKey: 'N° dossier', initiallyNotVisible: true},
            {path: 'assetInfos.presentationDate', tKey: 'Présentation', initiallyNotVisible: true},
            {path: 'assetInfos.fileStatus', display: 'name', tKey: 'Statut dossier', type: 'status', fieldPath: ['id', 'name', 'bStyle'], initiallyNotVisible: true},
            {path: 'assetInfos.fileDecisionDate', tKey: 'Date décision', initiallyNotVisible: true},
            {path: 'assetInfos.administrator', tKey: 'Gestionnaire'},
            {path: 'assetInfos.typeOfFile', tKey: 'Nature dossier', initiallyNotVisible: true},
            {path: 'assetInfos.benefactor', tKey: 'Bienfaiteur(rice)'},
            {path: 'beneficiary', display: 'zipCodeAndName', tKey: 'Bénéficiaire', initiallyNotVisible: true},
            {path: 'assetInfos.typeOfPropertyCategory', tKey: 'Catégorie / Nature du bien'},
            {path: 'assetInfos.identifier', tKey: 'Identifiant'},
            {path: 'beneficiaryShareInAssetEstimatedValue', initiallyNotVisible: true},
            {path: 'beneficiaryShareInAssetLiabilities', initiallyNotVisible: true},
            {path: 'beneficiaryOwnLiabilities', initiallyNotVisible: true},
            {path: 'beneficiaryShareInLiberalityRecordActsFees', initiallyNotVisible: true},
            {path: 'estimatedBeneficiaryNetValue'},
            {path: 'CNDAShareInEstimatedBeneficiaryNetValue'},
            {path: 'assetInfos.status', tKey: 'Statut bien', display: 'name', type: 'object', initiallyNotVisible: true},
            {path: 'updatedBy', tKey: 'MAJ par'},
            {path: 'updatedAt', tKey: 'MAJ le'},
        ]
    }
}
